import React from 'react';
import Footer from '../components/Footer';
import GradientLogo from '../components/common/GradientLogo';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-gradient-to-r from-[#0d0d0d] to-[#1a1a1a] text-white py-8">
        <div className="container mx-auto px-4">
          <div className="flex justify-center">
            <GradientLogo size="large" />
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl font-bold mb-8">Política de Privacidade</h1>
        
        <div className="prose prose-lg max-w-none space-y-6">
          <section>
            <h2 className="text-2xl font-semibold mb-4">1. Introdução</h2>
            <p>
              Esta Política de Privacidade descreve como a Java Dev Week ("nós", "nosso" ou "conosco") 
              coleta, usa e compartilha suas informações pessoais quando você utiliza nossos serviços.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">2. Informações Coletadas</h2>
            <p>Coletamos as seguintes informações:</p>
            <ul className="list-disc pl-6 mt-2">
              <li>Nome completo</li>
              <li>Endereço de e-mail</li>
              <li>Informações técnicas (endereço IP, navegador, idioma)</li>
              <li>Dados de uso e interação com o conteúdo</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">3. Uso das Informações</h2>
            <p>Utilizamos suas informações para:</p>
            <ul className="list-disc pl-6 mt-2">
              <li>Fornecer acesso ao conteúdo do evento</li>
              <li>Enviar comunicações sobre o evento</li>
              <li>Melhorar nossos serviços</li>
              <li>Cumprir obrigações legais</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">4. Compartilhamento de Dados</h2>
            <p>
              Não vendemos seus dados pessoais. Compartilhamos apenas com prestadores 
              de serviços necessários para a operação do evento, sempre com proteções 
              contratuais adequadas.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">5. Seus Direitos</h2>
            <p>Você tem direito a:</p>
            <ul className="list-disc pl-6 mt-2">
              <li>Acessar seus dados</li>
              <li>Corrigir dados incorretos</li>
              <li>Solicitar a exclusão dos dados</li>
              <li>Revogar consentimento</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">6. Segurança</h2>
            <p>
              Implementamos medidas técnicas e organizacionais apropriadas para proteger 
              seus dados pessoais contra acesso não autorizado, alteração, divulgação 
              ou destruição.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">7. Contato</h2>
            <p>
              Para exercer seus direitos ou tirar dúvidas sobre esta política, 
              entre em contato conosco através do e-mail: privacy@javadevweek.com
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">8. Atualizações</h2>
            <p>
              Esta política pode ser atualizada periodicamente. A versão mais recente 
              estará sempre disponível nesta página.
            </p>
            <p className="text-sm text-gray-600 mt-4">
              Última atualização: 19 de Maio de 2025
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;